document.addEventListener("DOMContentLoaded", () => {

    if(window.innerWidth < 768) return;

    const images = [...document.querySelectorAll(".mn-story-gallery__image")];

    const lightbox = document.querySelector(".mn-story-lightbox");

    const preview = document.querySelector(".mn-story-lightbox__image");

    const close = document.querySelector(".mn-story-lightbox__close");

    const prev = document.querySelector(".mn-story-lightbox__prev");

    const next = document.querySelector(".mn-story-lightbox__next");

    let current = 0;

    function open(index){

        current = index;

        preview.src = images[index].src;

        preview.alt = images[index].alt;

        lightbox.classList.add("active");

        document.body.style.overflow = "hidden";

    }

    function hide(){

        lightbox.classList.remove("active");

        document.body.style.overflow = "";

    }

    function previous(){

        current = current === 0 ? images.length - 1 : current - 1;

        open(current);

    }

    function following(){

        current = current === images.length - 1 ? 0 : current + 1;

        open(current);

    }

    images.forEach((image,index)=>{

        image.addEventListener("click",()=>{

            open(index);

        });

    });

    close.addEventListener("click",hide);

    prev.addEventListener("click",previous);

    next.addEventListener("click",following);

    lightbox.addEventListener("click",(e)=>{

        if(e.target===lightbox){

            hide();

        }

    });

    document.addEventListener("keydown",(e)=>{

        if(!lightbox.classList.contains("active")) return;

        if(e.key==="Escape") hide();

        if(e.key==="ArrowLeft") previous();

        if(e.key==="ArrowRight") following();

    });

});